module.exports = __webpack_public_path__ + "img/touxiang.4151a372.png";